import DefaultFilters from 'design-comuni-plone-theme/components/ItaliaTheme/Blocks/BandiSearch/DefaultFilters';

/*
  ***
  componente da customizzare nel proprio sito per modificare/aggiungere tipologie di Filtri
  ***
 */
const FiltersConfig = (dispatchFilter, path, data) => {
  // const subsite = useSelector((state) => state.subsite?.data);
  const defaultFilters = DefaultFilters(path, data);

  const defaultFilterTipologiaBando = data?.defaultQuerystring?.filter(
    (q) => q.i === 'tipologia_bando',
  );
  const default_tipologia_bando =
    defaultFilterTipologiaBando?.length > 0
      ? defaultFilterTipologiaBando[0].v
      : [];

  return {
    ...defaultFilters,
    tipologia_filter: {
      ...defaultFilters.tipologia_filter,
      widget: {
        ...defaultFilters.tipologia_filter.widget,
        props: {
          ...defaultFilters.tipologia_filter.widget.props,
          options: {
            ...defaultFilters.tipologia_filter.widget.props.options,
            filterOptions: (opt) => {
              return default_tipologia_bando?.length > 0
                ? default_tipologia_bando.indexOf(opt.value) >= 0
                : true;
            },
          },
          defaultValue:
            default_tipologia_bando?.length === 1
              ? default_tipologia_bando[0]
              : undefined,
        },
      },
    },
  };
};

export default FiltersConfig;
